module.exports = __webpack_public_path__ + "static/media/L.6c6793be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/L.jpg
// module id = 80
// module chunks = 0